export const APP_INIT = 'app/init';
export const APP_UNLOAD = 'app/unload';
export const API_MISMATCH = 'app/apiMismatch';
export const API_VERSION_STARTED = 'app/apiVersionStarted';
export const API_VERSION_SUCCESS = 'app/apiVersionSuccess';
export const API_VERSION_FAILED = 'app/apiVersionFailed';
